var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{},[_c('s-page',{attrs:{"breadcrumbs":_vm.breadcrumbs,"container":true}},[_c('cms-page',{attrs:{"page-id":_vm.cmsPageId,"content-only":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }